import React, { useState } from 'react'
import PropTypes from 'prop-types'

import AppBar from '../../ui/components/AppBar'
import SidebarMenu from '../../ui/components/SidebarMenu'
import LogoutModal from '../../ui/modals/logout'
import MENU_ITEMS from './menuItems'

const DesktopNavigation = ({ userName, email, onLogout }) => {
  const [isSidebarMenuOpen, setIsSidebarMenuOpen] = useState(true)

  const handleToggleSidebarMenu = () => {
    setIsSidebarMenuOpen(open => !open)
  }

  const [isLogoutModalOpen, setLogoutModalOpen] = useState(false)
  const openLogoutModal = () => setLogoutModalOpen(true)
  const closeLogoutModal = () => setLogoutModalOpen(false)
  return (
    <>
      <AppBar
        userName={userName}
        email={email}
        isOpen={isSidebarMenuOpen}
        onLogout={openLogoutModal}
        onToggleMenu={handleToggleSidebarMenu}
      />
      <SidebarMenu
        menuItems={MENU_ITEMS}
        isOpen={isSidebarMenuOpen}
        onToggleMenu={handleToggleSidebarMenu}
      />
      {isLogoutModalOpen ? (
        <LogoutModal onConfirm={onLogout} onCancel={closeLogoutModal} />
      ) : null}
    </>
  )
}

DesktopNavigation.propTypes = {
  userName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onLogout: PropTypes.func,
}

export default DesktopNavigation
